<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Melhoria/Manutenção"
                @click.stop="abrirModal()"
            ></i>
        </span>
		<b-modal
			v-model="showModal"
			id="modalInserirMovimentacao"
			hide-footer
		>
			<div slot="modal-title">
				Melhoria/Manutencão de Contrato -
				<b-badge variant="warning">Atualizar</b-badge>
			</div>
			<manutencao-form
				tipoOperacao="a"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterManutencoesAtualizadas="$emit('obterManutencoesAtualizadas')"
				:contrato="contrato"
				:idManutencaoContrato="idManutencaoContrato"
			></manutencao-form>
		</b-modal>
    </div>
</template>

<script>
import ManutencaoForm from './ManutencaoForm'

export default {
	components: {
		ManutencaoForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		idManutencaoContrato: {
            type: String,
            default: () => ('')
        }
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
